import React from 'react';
import ReactDOM from 'react-dom';

import Wahanda from 'common/wahanda';
import { Initializer } from 'common/types/initializers';

import { ExportReasonDialog, ExportReason } from './ExportReasonDialog';

const container = Wahanda.Dialogs.getReactContainer();

interface Params {
  onExport: (reason: ExportReason) => void;
  onCancel: () => void;
}

function destroy() {
  ReactDOM.unmountComponentAtNode(container);
}

export const ExportReasonDialogInitializer = (params: Params): Initializer => {
  const handleExport = (reason: ExportReason) => {
    destroy();
    params.onExport(reason);
  };

  const handleCancel = () => {
    destroy();
    params.onCancel();
  };

  return {
    destroy: () => ReactDOM.unmountComponentAtNode(container),
    render: () => {
      ReactDOM.render(
        <ExportReasonDialog onExport={handleExport} onCancel={handleCancel} />,
        container,
      );
    },
  };
};
